// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","667":"1d8bd30f","821":"b34f13c6"}[chunkId] + ".chunk.js";
};